import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default class ArticlesSlider {
  constructor($elem) {
    this.$elem = $elem;
    this.init();
  }

  init() {
    new Swiper(this.$elem.find(".swiper")[0], {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      speed: 400,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      modules: [Navigation],
    });
  }
}
